import React, { useState } from "react";
import "./FarmerStockEditor.css";

const FarmerStockEditor = ({ product, onSave, onClose }) => {
  const [price, setPrice] = useState(product.price);
  const [stock, setStock] = useState(product.stock);

  return (
    <div className="stock-editor" onClick={onClose}>
      <div className="editor-content" onClick={(e) => e.stopPropagation()}>
        <h3>Edit {product.name}</h3>
        <label>
          Price
          <input
            type="number"
            value={price}
            onChange={(e) => setPrice(e.target.value)}
            className="editor-input"
          />
        </label>
        <label>
          Stock
          <input
            type="number"
            value={stock}
            onChange={(e) => setStock(e.target.value)}
            className="editor-input"
          />
        </label>
        <div className="editor-actions">
          <button
            className="save-btn"
            onClick={() => onSave({ ...product, price, stock })}
          >
            Save
          </button>
          <button className="cancel-btn" onClick={onClose}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default FarmerStockEditor;
